/**
 * (c) 2024, Micro:bit Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
import { isPublicFacingStage } from "../environment";

// We might move these into the deployment config in future
// They'll also need to become language aware
const microbitOrgBaseUrl = isPublicFacingStage()
  ? "https://microbit.org/"
  : "https://stage.microbit.org/";

const langPath = (languageId: string) =>
  languageId === "en" ? "" : `${languageId.toLowerCase()}/`;

const learnMoreUrlLanguages = ["fr", "ga-IE", "nl", "pl", "pt-BR"];

export const projectUrl = (slug: string, language: string) =>
  `${microbitOrgBaseUrl}${langPath(
    language
  )}projects/make-it-code-it/${encodeURIComponent(slug)}/`;

export const lessonUrl = (slug: string) =>
  `${microbitOrgBaseUrl}teach/lessons/${encodeURIComponent(slug)}/`;

export const userGuideUrl = () =>
  `${microbitOrgBaseUrl}get-started/user-guide/microbit-createai/`;

export const landingPageUrl = (language: string) =>
  `${microbitOrgBaseUrl}${langPath(language)}ai/`;

export const supportSiteFolderUrl = () =>
  "https://support.microbit.org/support/solutions/folders/19000176257";

export const accessibilityUrl = () => `${microbitOrgBaseUrl}accessibility/`;

export const appStoreUrl = () =>
  "https://apps.apple.com/app/micro-bit-createai/id6757603093";

export const googlePlayUrl = () =>
  "https://play.google.com/store/apps/details?id=org.microbit.createai";

export const learnMoreUrl = (languageId: string) =>
  `${microbitOrgBaseUrl}${langPath(
    learnMoreUrlLanguages.includes(languageId) ? languageId : "en"
  )}createai/`;
